/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Resend_Invitation_CancelInputs */

const en_users_resend_invitation_cancel = /** @type {(inputs: Users_Resend_Invitation_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

const pt_br2_users_resend_invitation_cancel = /** @type {(inputs: Users_Resend_Invitation_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar`)
};

/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Users_Resend_Invitation_CancelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_resend_invitation_cancel = /** @type {((inputs?: Users_Resend_Invitation_CancelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Resend_Invitation_CancelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_resend_invitation_cancel(inputs)
	return pt_br2_users_resend_invitation_cancel(inputs)
});